"use strict";

define('rs/form/editelement',['jquery', 'rs/helper', 'underscore', 'vertebrae', 'evisions/redactor.plugins/href.location.redactor.plugin'], function ($, helper, _, Vertebrae) {
  var EditableElement = function EditableElement(container, selector) {
    this.$el = $(container);
    this.selector = selector;
    this._unbind = [];
    this._callbacks = {
      edit: $.Callbacks()
    };
    this._getters = {
      width: function width() {
        return 0;
      },
      rich: function rich() {
        return false;
      },
      redactorOptions: function redactorOptions() {
        return {};
      },
      container: function container() {
        return this.$el;
      },
      maxLength: function maxLength() {
        return 0;
      }
    };
  };
  EditableElement.prototype = {
    edit: function edit(fn) {
      this._callbacks.edit.add(fn);
      return this;
    },
    enterEdit: function enterEdit(el) {
      _.defer(function () {
        el.focus().trigger($.Event('click')).focus();
      });
      return this;
    },
    width: function width(fn) {
      this._getters.width = fn;
      return this;
    },
    rich: function rich(fn) {
      this._getters.rich = fn;
      return this;
    },
    redactorOptions: function redactorOptions(fn) {
      this._getters.redactorOptions = fn;
      return this;
    },
    container: function container(fn) {
      this._getters.container = fn;
      return this;
    },
    maxLength: function maxLength(fn) {
      this._getters.maxLength = fn;
      return this;
    },
    getWidth: function getWidth(el) {
      return this._getters.width.call(this, el);
    },
    getRich: function getRich(el) {
      return this._getters.rich.call(this, el);
    },
    getRedactorOptions: function getRedactorOptions(el) {
      return this._getters.redactorOptions.call(this, el);
    },
    getMaxLength: function getMaxLength(el) {
      return this._getters.maxLength.call(this, el);
    },
    getContainer: function getContainer(el) {
      return this._getters.container.call(this, el);
    },
    editInput: function editInput(el, ev) {
      if (EditableElement.currentShowing) {
        EditableElement._allowHideFirst = true;
      }
      if (!ev.originalEvent) {
        ev.originalEvent = {};
      }
      ev.originalEvent._clickFlag = true;
      EditableElement.currentShowing = this;
      var width = el.outerWidth(),
        height = el.height(),
        offset = el.offset(),
        elTop = offset.top,
        elLeft = offset.left,
        container = this.getContainer(el),
        contOffset = container.offset(),
        contTop = contOffset.top,
        contLeft = contOffset.left,
        that = this,
        unbindBody = null,
        bodyClickFn = null,
        $body = $(document.body),
        inputEditContainer = $("<div/>").addClass("editable-input-container"),
        input = null,
        userWidth = this.getWidth(el),
        useRich = this.getRich(el),
        maxLength = this.getMaxLength(el),
        content = useRich ? el.html() : el.text();
      inputEditContainer.html(Vertebrae.View.template('editelement'));
      input = inputEditContainer.find('textarea');
      container.append(inputEditContainer);
      if (maxLength) {
        input.attr("maxlength", maxLength);
      }
      inputEditContainer.css({
        'position': 'absolute',
        'top': elTop - contTop - 3,
        'left': elLeft - contLeft,
        'min-width': width,
        'min-height': height,
        color: el.css('color'),
        'font-size': el.css('font-size')
      });
      if (userWidth) {
        if (el.attr('data-property') == "label" && !el.hasClass('section-label')) {
          input.css('min-width', 100);
        } else {
          input.css('max-width', userWidth);
        }
      }
      input.val(content).select().css({
        'width': userWidth || width
      });
      unbindBody = function unbindBody() {
        $body.off('click', bodyClickFn);
      };
      bodyClickFn = function bodyClickFn(ev) {
        var redactorModalOpened = $('#redactor_modal').css('display') == 'block' || $('.modal').css('display') == 'block';
        if (!redactorModalOpened && (ev.originalEvent._clickFlag !== true || EditableElement._allowHideFirst)) {
          unbindBody();
          that.inputDidBlur(input, el, ev, inputEditContainer);
        }
      };
      inputEditContainer.on('click', function (ev) {
        ev.stopPropagation();
        ev.originalEvent._clickFlag = true;
      }).find('.editable-input-controls').on('mousedown', '.accept', function (ev) {
        unbindBody();
        that.uneditInput(el, input, inputEditContainer);
        ev.stopPropagation();
      }).on('keydown', '.accept', function (ev) {
        if (13 === ev.keyCode) {
          unbindBody();
          that.uneditInput(el, input, inputEditContainer);
          ev.stopPropagation();
        }
      }).on('mousedown', '.cancel', function (ev) {
        unbindBody();
        that.cancelEditInput(el, input, inputEditContainer);
        ev.stopPropagation();
      }).on('keydown', '.cancel', function (ev) {
        if (13 === ev.keyCode) {
          unbindBody();
          that.cancelEditInput(el, input, inputEditContainer);
          ev.stopPropagation();
        }
      }).on('mousedown', '.editable-btn', function (ev) {
        ev.stopPropagation();
      });
      $body.on('click', bodyClickFn);
      if (useRich) {
        _.defer(function () {
          inputEditContainer.find('.redactor_box').width(userWidth || width);
          inputEditContainer.find('.redactor_editor').on('keydown', function (ev) {
            that.keyWasPressed(input, el, ev, unbindBody, inputEditContainer);
          });
        });
        this.setupRichText(input, inputEditContainer);
      } else {
        input.one('blur', function (ev) {
          unbindBody();
          that.inputDidBlur(input, el, ev, inputEditContainer);
        }).on('click', function (ev) {
          ev.originalEvent._clickFlag = true;
        }).on('keydown', function (ev) {
          that.keyWasPressed(input, el, ev, unbindBody, inputEditContainer);
        });
        this.resize(input);
        setTimeout(function () {
          input.focus();
        }, 0);
      }
    },
    setupRichText: function setupRichText(input, inputEditContainer) {
      var opts = {
        linebreaks: true,
        minHeight: 100,
        tabFocus: false,
        plugins: ['hrefLocation'],
        buttons: ['bold', 'italic', 'underline', 'deleted', '|', 'unorderedlist', 'orderedlist', '|', 'link']
      };
      $.extend(opts, this.getRedactorOptions() || {});
      input.redactor(opts);
      input.redactor('focus');
      _.defer(function () {
        input.redactor('selectionAll');
      });
      var stopBubbles = function stopBubbles(ev) {
        ev.stopPropagation();
      };
      inputEditContainer.find('.editable-input-textarea-container').on('click', stopBubbles).on('mousedown', stopBubbles);
    },
    resize: function resize(input) {
      var scrollHeight = input.get(0).scrollHeight;
      if (scrollHeight < 300) {
        input.css("overflow", 'hidden');
        _.defer(function () {
          scrollHeight = input.get(0).scrollHeight;
          if (input.height() + 10 < scrollHeight) {
            input.height(scrollHeight);
            input.css("overflow", 'auto');
          }
        });
      }
    },
    keyWasPressed: function keyWasPressed(input, el, ev, unbind, inputEditContainer) {
      var code = ev.keyCode;
      if (code === 27) {
        unbind();
        this.cancelEditInput(el, input, inputEditContainer);
      }
      if (!this.getRich(el)) {
        this.resize(input);
      }
    },
    inputDidBlur: function inputDidBlur(input, el, ev, inputEditContainer) {
      this.uneditInput(el, input, inputEditContainer);
    },
    uneditInput: function uneditInput(el, input, inputEditContainer, noValueChange) {
      if (!EditableElement._allowHideFirst) {
        EditableElement.currentShowing = null;
      }
      EditableElement._allowHideFirst = false;
      if (this.getRich(el)) {
        el.html(input.val());
      } else {
        el.text(input.val());
      }
      input.off();
      inputEditContainer.remove();
      this._callbacks.edit.fire(el, el.data('property'), input.val(), noValueChange);
    },
    cancelEditInput: function cancelEditInput(el, input, inputEditContainer) {
      if (this.getRich(el)) {
        input.val(el.html());
      } else {
        input.val(el.text());
      }
      this.uneditInput(el, input, inputEditContainer, true);
    },
    bind: function bind() {
      var that = this,
        clickCB = null;
      clickCB = function clickCB(ev) {
        that.handleClick(ev);
      };
      mousedownStopper = function mousedownStopper(ev) {
        ev.stopPropagation();
      };
      this._unbind.push(clickCB);
      this._unbind.push(mousedownStopper);
      clickCB._type = 'click';
      mousedownStopper._type = 'mousedown';
      this.$el.on('click', this.selector, clickCB);
      this.$el.on('mousedown', this.selector, mousedownStopper);
    },
    unbind: function unbind() {
      var unbind = this._unbind || [],
        len = unbind.length || 0,
        fn = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        fn = unbind[i];
        this.$el.off(fn._type, this.selector, fn);
      }
    },
    destroy: function destroy() {
      this.unbind();
      this._unbind = null;
      this.$el = null;
      this.selector = null;
    },
    handleClick: function handleClick(ev) {
      var el = $(ev.currentTarget);
      if (!el.hasClass('disabled')) {
        this.editInput(el, ev);
      }
    }
  };
  EditableElement.delegate = function (container, selector) {
    var editEl = new EditableElement(container, selector);
    editEl.bind();
    return editEl;
  };
  return EditableElement;
});

